import { SOURCE_WEBAPP } from 'src/utils/constant'
import { serializeQuery } from './api.utils'
import { BaseApi } from './base.api'

export class LookupWordApi extends BaseApi {
	constructor() {
		super('')
	}

	async getSoundWord(word) {
		const rs = await this.get(`pronunciation?word=${word}`)
		return Buffer.from(rs, 'base64') // decrypt
	}

	async getSpellingWord(word) {
		// Prefer dictionary-backed spelling endpoint (stable, no external scraping TLS issues).
		// Keep legacy fallback for backward compatibility with older environments.
		try {
			return await this.get(`api/word/spellings?word=${word}`)
		} catch (_err) {
			const rs = await this.get(`spelling?word=${word}`)
			return rs
		}
	}

	async getEnglishDefinitionPublicly(word) {
		const rs = await this.get(`lookup?word=${word}`)
		if (rs && rs.word) {
			const word = rs.word.match(/[a-zA-Z\s]*/gi)
			if (word) {
				rs.word = word[0]
			}
		}
		return rs
	}

	async getVietnameseDefinitionPublicly(word) {
		const rs = await this.get(`lookup-vi?word=${word}`)
		return rs
	}

	async getDefinitionFromDict(word) {
		const rs = await this.get(`api/word/dict?word=${word}`)
		return rs
	}

	/**
	 *
	 * @param {word} data
	 * @returns
	 */
	async translate(data) {
		const query = serializeQuery(data)
		const rs = await this.get(
			`api/translate/public/vi?${query}&limitViDefinition=2&limitEnDefinition=2&translatedFrom=${SOURCE_WEBAPP}`
		)
		return rs
	}
}
